import { defineSlotRecipe } from '@chakra-ui/react';
export const selectRecipe = defineSlotRecipe({
    className: 'chakra-select',
    slots: ['root', 'trigger', 'content', 'item', 'itemText', 'itemIndicator', 'indicator'],
    base: {
        root: {
            colorPalette: 'primary',
        },
        indicator: {
            width: '4',
            height: '4',
        },
    },
    variants: {
        variant: {
            outline: {
                trigger: {
                    rounded: 'md',
                    borderWidth: '1px',
                    borderColor: 'border',
                    bg: 'bg',
                    fontWeight: 'normal',
                    cursor: 'pointer',
                    _hover: {
                        borderColor: 'border.emphasized',
                    },
                    _focus: {
                        outline: '2px solid',
                        outlineOffset: '0.5px',
                        outlineColor: 'colorPalette.focusRing/15',
                        zIndex: 1,
                        borderColor: 'colorPalette.focusRing',
                        boxShadow: '0 0 0 1px var(--chakra-colors-colorPalette-focusRing)',
                    },
                    _disabled: {
                        opacity: 0.4,
                        cursor: 'not-allowed',
                    },
                    _invalid: {
                        borderColor: 'border.error',
                        _focus: {
                            borderColor: 'border.error',
                            boxShadow: '0 0 0 1px var(--chakra-colors-border-error)',
                        },
                    },
                },
                content: {
                    bg: 'bg',
                    borderWidth: '1px',
                    borderColor: 'border',
                    rounded: 'lg',
                },
                item: {
                    rounded: 'md',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outline',
    },
});
